import * as yup from 'yup'
import { CompanyDto } from './companyDto'

export class VehicleSpecialBondRequestDto {
  insuranceCompany?: CompanyDto = undefined
  insuranceCompanyEmail?: string = undefined
  specialNotes?: string = undefined
}

export const VehicleSpecialBondRequestValidationSchema = yup.object({
  insuranceCompany: yup.object().required('Insurance Company is required.'),
  insuranceCompanyEmail: yup.string().required('Insurance Company Email is required.'),
  specialNote: yup.string().max(200, 'Special Notes cannot be more than 200 characters').nullable()
})
